import { performanceLog } from 'modules/core/lib/datadogLogger'

interface PerformanceLogData {
  appIdentifier: string
  companyName: string
  companyId: string
  companySize: string
  userEmail: string | null | undefined
  userId: string
  userIsAdmin: boolean
}

export default function runPerformanceLog({ appIdentifier, ...logData }: PerformanceLogData) {
  if (typeof window.performance.mark !== 'function') return

  // Performance is not available on Safari 10
  window.performance.mark('app_load_complete')
  window.performance.measure('load_time', 'app_started', 'app_load_complete')
  performanceLog(
    {
      name: appIdentifier,
      start_time_name: 'app_started',
      measure_name: 'load_time',
    },
    logData
  )
}
